import api from './apiLibrary';

const API = {
    getMatches(params) {
        return api.get('/api/data/game', params);
    },
    getMatch(id, params) {
        return api.get(`/api/data/game/${id}`, params);
    },

    getMatchDetails(id, params) {
        return api.get(`/api/game-details/${id}`, params);
    },

    getMatchStats(id, params) {
        return api.get(`/api/team-stats/game/${id}`, params);
    },
    createMatch(data) {
        return api.post('/api/data/game', data);
    },
    editMatch(id, data) {
        return api.put(`/api/data/game/${id}`, data);
    },
    deleteMatch(id) {
        return api.delete(`/api/data/game/${id}`);
    },
    getMatchStatistics(params) {
        return api.get('/api/admin/game/statistics', params);
    },
    getVenues(params) {
        return api.get('/api/data/venue', params);
    },
    getPhases(params) {
        return api.get(`/api/data/phase`, params);
    },
    getLineup(matchID, params) {
        return api.get(`/api/lineup/${matchID}`, params);
    },
    getQualifications(params) {
        return api.get('/api/data/qualification', params);
    },
    getCHLMatches(params) {
        return api.get('/api/chl/phases', params);
    },
    updateMatchesBySeason(data) {
        return api.post('/api/game-update/season', data);
    },
};

export default API;
